const createDraftFields = (t) => [
  {
    key: 'movements',
    label: '',
    thClass: 'th-movements',
  },
  {
    key: 'delivery_order.number',
    label: t('fleetTask.activityTable.fields.deliveryNumber'),
    thClass: 'th-do',
  },
  {
    key: 'activity_type',
    label: t('fleetTask.activityTable.fields.activity'),
    thClass: 'th-activity',
  },
  {
    key: 'shipment_number',
    label: t('fleetTask.activityTable.fields.shipmentNumber'),
    thClass: 'th-shipment',
  },
  {
    key: 'reference_number_internal',
    label: t('fleetTask.activityTable.fields.referenceNumber'),
    thClass: 'th-reference-internal',
  },
  {
    key: 'reference_number',
    label: t('fleetTask.activityTable.fields.refOrder'),
    thClass: 'th-reference',
    scopes: ['tms-integration-accurate:create', 'tms-integration-accurate:read', 'tms-integration-accurate:delete', 'tms-integration-accurate:update'],
  },
  {
    key: 'delivery_order.customer.name',
    label: t('fleetTask.activityTable.fields.customer'),
    thClass: 'head-customer',
  },
  {
    key: 'target_pickup_delivery',
    label: t('fleetTask.activityTable.fields.targetPickupDelivery'),
    thClass: 'head-target',
  },
  {
    key: 'delivery_order.total_weight',
    label: t('fleetTask.activityTable.fields.weight'),
    thClass: 'th-weight-volume',
  },
  {
    key: 'delivery_order.total_volume',
    label: t('fleetTask.activityTable.fields.volume'),
    thClass: 'th-weight-volume',
  },
  {
    key: 'remove',
    label: '',
    thClass: 'th-remove',
  },
]

const createScheduledFields = (t) => [
  {
    key: 'delivery_order.number',
    label: t('fleetTask.activityTable.fields.deliveryNumber'),
    thClass: 'th-do',
  },
  {
    key: 'activity_type',
    label: t('fleetTask.activityTable.fields.activity'),
    thClass: 'th-activity',
  },
  {
    key: 'shipment_number',
    label: t('fleetTask.activityTable.fields.shipmentNumber'),
    thClass: 'th-shipment',
  },
  {
    key: 'reference_number_internal',
    label: t('fleetTask.activityTable.fields.referenceNumber'),
    thClass: 'th-reference-internal',
  },
  {
    key: 'reference_number',
    label: t('fleetTask.activityTable.fields.refOrder'),
    thClass: 'th-reference',
    scopes: ['tms-integration-accurate:create', 'tms-integration-accurate:read', 'tms-integration-accurate:delete', 'tms-integration-accurate:update'],
  },
  {
    key: 'status',
    label: t('fleetTask.activityTable.fields.status')
  },
  {
    key: 'delivery_order.customer.name',
    label: t('fleetTask.activityTable.fields.customer'),
    thClass: 'head-customer',
  },
  {
    key: 'address',
    label: t('fleetTask.activityTable.fields.locationName'),
  },
  {
    key: 'target_pickup_delivery',
    label: t('fleetTask.activityTable.fields.targetPickupDelivery'),
    thClass: 'head-target',
  },
  {
    key: 'completed_on',
    label: t('fleetTask.activityTable.fields.actualPickupDeliveryTime'),
  },
  {
    key: 'delivery_order.total_weight',
    label: t('fleetTask.activityTable.fields.weight'),
    thClass: 'th-weight-volume',
  },
  {
    key: 'delivery_order.total_volume',
    label: t('fleetTask.activityTable.fields.volume'),
    thClass: 'th-weight-volume',
  },
  {
    key: 'complete',
    label: '',
    thClass: 'th-complete',
  },
]

const createEndedFields = (t) => [
  {
    key: 'delivery_order.number',
    label: t('fleetTask.activityTable.fields.deliveryNumber'),
    thClass: 'th-do',
  },
  {
    key: 'activity_type',
    label: t('fleetTask.activityTable.fields.activity'),
    thClass: 'th-activity',
  },
  {
    key: 'shipment_number',
    label: t('fleetTask.activityTable.fields.shipmentNumber'),
    thClass: 'th-shipment',
  },
  {
    key: 'reference_number_internal',
    label: t('fleetTask.activityTable.fields.referenceNumber'),
    thClass: 'th-reference-internal',
  },
  {
    key: 'reference_number',
    label: t('fleetTask.activityTable.fields.refOrder'),
    thClass: 'th-reference',
    scopes: ['tms-integration-accurate:create', 'tms-integration-accurate:read', 'tms-integration-accurate:delete', 'tms-integration-accurate:update'],
  },
  {
    key: 'status',
    label: t('fleetTask.activityTable.fields.status')
  },
  {
    key: 'delivery_order.customer.name',
    label: t('fleetTask.activityTable.fields.customer'),
    thClass: 'head-customer',
  },
  {
    key: 'address',
    label: t('fleetTask.activityTable.fields.locationName'),
  },
  {
    key: 'target_pickup_delivery',
    label: t('fleetTask.activityTable.fields.targetPickupDelivery'),
    thClass: 'head-target',
  },
  {
    key: 'completed_on',
    label: t('fleetTask.activityTable.fields.actualPickupDeliveryTime'),
  },
  {
    key: 'delivery_order.total_weight',
    label: t('fleetTask.activityTable.fields.weight'),
    thClass: 'th-weight-volume',
  },
  {
    key: 'delivery_order.total_volume',
    label: t('fleetTask.activityTable.fields.volume'),
    thClass: 'th-weight-volume',
  },
  {
    key: 'complete',
    label: '',
    thClass: 'th-complete',
  },
]

const createCanceledFields = (t) => [
  {
    key: 'delivery_order.number',
    label: t('fleetTask.activityTable.fields.deliveryNumber'),
    thClass: 'th-do',
  },
  {
    key: 'activity_type',
    label: t('fleetTask.activityTable.fields.activity'),
    thClass: 'th-activity',
  },
  {
    key: 'shipment_number',
    label: t('fleetTask.activityTable.fields.shipmentNumber'),
    thClass: 'th-shipment',
  },
  {
    key: 'reference_number_internal',
    label: t('fleetTask.activityTable.fields.referenceNumber'),
    thClass: 'th-reference-internal',
  },
  {
    key: 'reference_number',
    label: t('fleetTask.activityTable.fields.refOrder'),
    thClass: 'th-reference',
    scopes: ['tms-integration-accurate:create', 'tms-integration-accurate:read', 'tms-integration-accurate:delete', 'tms-integration-accurate:update'],
  },
  {
    key: 'status',
    label: t('fleetTask.activityTable.fields.status')
  },
  {
    key: 'delivery_order.customer.name',
    label: t('fleetTask.activityTable.fields.customer'),
    thClass: 'head-customer',
  },
  {
    key: 'address',
    label: t('fleetTask.activityTable.fields.locationName'),
  },
  {
    key: 'target_pickup_delivery',
    label: t('fleetTask.activityTable.fields.targetPickupDelivery'),
    thClass: 'head-target',
  },
  {
    key: 'completed_on',
    label: t('fleetTask.activityTable.fields.actualPickupDeliveryTime'),
  },
  {
    key: 'delivery_order.total_weight',
    label: t('fleetTask.activityTable.fields.weight'),
    thClass: 'th-weight-volume',
  },
  {
    key: 'delivery_order.total_volume',
    label: t('fleetTask.activityTable.fields.volume'),
    thClass: 'th-weight-volume',
  },
]


export const getFields = (t) => {
  const draftFields = createDraftFields(t)
  const scheduledFields = createScheduledFields(t)
  const endedFields = createEndedFields(t)
  const canceledFields = createCanceledFields(t)
  const hasVendorFields = endedFields.filter(field => field.key !== 'complete')

  return {
    'Temporary': draftFields,
    'Draf': draftFields,
    'Dijadwalkan': scheduledFields,
    'Perjalanan': scheduledFields,
    'Selesai': endedFields,
    'Dibatalkan': canceledFields,
    'hasVendor': hasVendorFields,
    'Ditolak': draftFields,
    'Menunggu Persetujuan': canceledFields,
    'Disetujui': scheduledFields,
  }
}
